import { ModuleType } from "../enums/moduleType";

export function listRfSlots(originalList) {
	const items = [];
	for (const item of originalList) {
		if ([ModuleType.RfReceiverModule, ModuleType.IpRfReceiverModule].includes(item.type)) {
			for (let i = 1; i <= 4; i++) {
				if (item.subModules[i - 1]) {
					items.push({
						...item,
						name: item.subModules[i - 1]?.name,
						subModuleIndex: i - 1,
					})
				}
			}
			continue;
		}
		items.push(item);
	}
	return items;
}